import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=d8f6d9c2&scoped=true&"
import script from "./pdfViewer.vue?vue&type=script&lang=js&"
export * from "./pdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./pdfViewer.vue?vue&type=style&index=0&id=d8f6d9c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f6d9c2",
  null
  
)

export default component.exports